import { Z_INDEX } from '@/constants/styleConstants';
import { classnames } from '@/helpers';
import { Fragment, ReactNode } from 'react';
import FocusLock from 'react-focus-lock';
import { UsePanelSlideOutViewManagerOutput } from './PanelSlideOutView.types';

const PanelSlideOutView = ({
  children,
  id,
  open,
  show,
  showOverlay,
  onKeyDown,
  onClose,
  ariaLabelledby,
}: UsePanelSlideOutViewManagerOutput & { id: string; ariaLabelledby?: string; children: ReactNode }) => {
  return (
    <Fragment>
      <FocusLock returnFocus disabled={!open}>
        <aside
          id={id}
          {...(ariaLabelledby && { 'aria-labelledby': ariaLabelledby })}
          role="dialog"
          className={classnames(
            'no-scrollbar px-md bg-surface_l4 fixed right-0 top-0 h-full overflow-y-auto transition-transform duration-200',
            // responsive width: 90% by default, but cap at 400px on medium screens and above
            'w-[90vw] max-w-[400px]',
            open ? 'translate-x-0 [transform:translateX(100%)_translateX(-100%)]' : 'translate-x-full',
            show ? '' : 'invisible',
          )}
          style={{ zIndex: Z_INDEX.SLIDE_OUT_PANEL }}
          aria-hidden={!open}
          onKeyDown={onKeyDown}>
          {children}
        </aside>
      </FocusLock>
      {open && (
        <div
          onClick={() => onClose()}
          style={{ zIndex: Z_INDEX.SLIDE_OUT_PANELL_OVERLAY }}
          className={classnames(
            'bg-overlay-50 fixed inset-0 transition-opacity duration-300',
            showOverlay ? 'opacity-100' : 'opacity-100',
          )}
        />
      )}
    </Fragment>
  );
};

export default PanelSlideOutView;
